<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Portal-Document-Claim-Manage",
  short_name: "Manage Claim Document",
  path: "manage/:id?",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
